import {
  faAnglesUpDown,
  faAngleDown,
  faAngleUp,
  faArrowDown,
  faArrowDownRight,
  faArrowDownWideShort,
  faArrowLeft,
  faArrowRightFromBracket,
  faArrowRotateRight,
  faArrowsRepeat,
  faArrowsRetweet,
  faArrowsUpDownLeftRight,
  faArrowUp,
  faArrowUpRight,
  faBan,
  faBars,
  faQuestionCircle,
  faExpandAlt,
  faBell,
  faBellExclamation,
  faBellRing,
  faBoltLightning,
  faBuilding,
  faCalendarRange,
  faCartFlatbedBoxes,
  faChartColumn,
  faChartMixed,
  faChartMixedUpCircleDollar,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleBolt,
  faCircleCheck,
  faCircleInfo,
  faCircleMinus,
  faCirclePause,
  faCirclePlay,
  faCity,
  faClockRotateLeft,
  faClose,
  faCloud,
  faCloudArrowDown,
  faCloudArrowUp,
  faCloudSunRain,
  faCodeBranch,
  faCopy,
  faDatabase,
  faDisplayChartUp,
  faDisplayChartUpCircleDollar,
  faDownload,
  faDroplet,
  faEarthAfrica,
  faEllipsis,
  faEnvelopeOpenDollar,
  faEye,
  faEyeSlash,
  faFile,
  faFileArrowDown,
  faFileBracketsCurly,
  faFileCheck,
  faFileCode,
  faFileCsv,
  faFileExcel,
  faFileExport,
  faFileImport,
  faFileImage,
  faFileInvoiceDollar,
  faFileLines,
  faFilePdf,
  faFilePowerpoint,
  faFileUser,
  faFileWord,
  faFileXml,
  faFileZip,
  faFireFlameCurved,
  faFlag,
  faFolderOpen,
  faGauge,
  faGaugeHigh,
  faGaugeSimpleMax,
  faGear,
  faGlobe,
  faHandshake,
  faHandWave,
  faHourglassClock,
  faHouse,
  faHouseBlank,
  faHouseChimneyUser,
  faImagePolaroid,
  faInbox,
  faLayerGroup,
  faLeaf,
  faLinkHorizontal,
  faLinkHorizontalSlash,
  faLocationCrosshairs,
  faLocationDot,
  faLock,
  faLockOpen,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMapLocationDot,
  faMeter,
  faMobileButton,
  faNetworkWired,
  faNewspaper,
  faOilCanDrip,
  faPaperclip,
  faPen,
  faPenToSquare,
  faPieChart,
  faPipeCircleCheck,
  faPlus,
  faRectangle,
  faRouter,
  faScrubber,
  faSearch,
  faShareNodes,
  faShieldCheck,
  faShieldSlash,
  faSignal,
  faSignalBarsSlash,
  faSparkles,
  faSpinnerThird,
  faStar,
  faSuitcase,
  faTable,
  faTableLayout,
  faTemperatureSnow,
  faTemperatureThreeQuarters,
  faThumbsUp,
  faThumbtack,
  faTimer,
  faToolbox,
  faTrashCan,
  faTree,
  faTriangleExclamation,
  faUpload,
  faUser,
  faUserGear,
  faUsers,
  faUserTag,
  faWaterArrowUp,
  faWifi,
  faWineBottle,
  faWrench,
  faXmark,
  faXmarkCircle,
  faMerge,
} from '@fortawesome/pro-light-svg-icons';
import {
  faChevronLeft as faChevronLeftSolid,
  faChevronRight as faChevronRightSolid,
  faCircle,
  faCircleCheck as faCircleCheckSolid,
  faCircleExclamation,
  faCircleInfo as faCircleInfoSolid,
  faCircleMinus as faCircleMinusSolid,
  faCirclePlus as faCirclePlusSolid,
  faCircleXmark as faCircleXmarkSolid,
  faDiamondExclamation,
  faDot,
  faDoNotEnter,
  faEllipsisStrokeVertical,
  faFireFlameCurved as faFireFlameCurvedSolid,
  faFloppyDisk,
  faGridHorizontal,
  faGripDots,
  faInfo,
  faInfoSquare as faInfoSquareSolid,
  faMap,
  faMessageQuestion,
  faPlusLarge,
  faThumbTack as faThumbtackSolid,
  faTriangleExclamation as faTriangleExclamationSolid,
} from '@fortawesome/pro-solid-svg-icons';

export const FONT_AWESOME_ICONS = {
  air: faWineBottle,
  analysis: faChartMixed,
  angelsUpDown: faAnglesUpDown,
  angleDown: faAngleDown,
  angleUp: faAngleUp,
  arrowDown: faArrowDown,
  arrowDownRight: faArrowDownRight,
  arrowLeft: faArrowLeft,
  arrowUp: faArrowUp,
  arrowUpRight: faArrowUpRight,
  auditLog: faClockRotateLeft,
  ban: faBan,
  bars: faBars,
  bellExclamation: faBellExclamation,
  bellRing: faBellRing,
  building: faBuilding,
  calendarRange: faCalendarRange,
  carbonFootprint: faEarthAfrica,
  cartFlatbedBoxes: faCartFlatbedBoxes,
  chartUpCircleDollar: faDisplayChartUpCircleDollar,
  check: faCheck,
  chevronDown: faChevronDown,
  chevronLeft: faChevronLeft,
  chevronLeftSolid: faChevronLeftSolid,
  chevronRight: faChevronRight,
  chevronRightSolid: faChevronRightSolid,
  chevronUp: faChevronUp,
  circleCheck: faCircleCheck,
  circleCheckSolid: faCircleCheckSolid,
  circleExclamation: faCircleExclamation,
  circleMinus: faCircleMinus,
  circleMinusSolid: faCircleMinusSolid,
  circlePause: faCirclePause,
  circlePlay: faCirclePlay,
  circlePlusSolid: faCirclePlusSolid,
  circleSolid: faCircle,
  city: faCity,
  close: faClose,
  cloudDownload: faCloudArrowDown,
  cloudUpload: faCloudArrowUp,
  codeBranch: faCodeBranch,
  columnChart: faChartColumn,
  copy: faCopy,
  cost: faChartMixedUpCircleDollar,
  dashboard: faDisplayChartUp,
  database: faDatabase,
  delete: faTrashCan,
  diamondExclamationSolid: faDiamondExclamation,
  doNotEnter: faDoNotEnter,
  dot: faDot,
  download: faDownload,
  edit: faPen,
  editSquare: faPenToSquare,
  electricity: faBoltLightning,
  ellipses: faEllipsis,
  ELTO: faOilCanDrip,
  envelopeDollar: faEnvelopeOpenDollar,
  excelDocument: faFileExcel,
  expandAlt: faExpandAlt,
  exports: faFileArrowDown,
  eye: faEye,
  eyeSlash: faEyeSlash,
  favourites: faStar,
  file: faFile,
  fileCheck: faFileCheck,
  fileCsv: faFileCsv,
  fileExcel: faFileExcel,
  fileExport: faFileExport,
  fileImport: faFileImport,
  fileImage: faFileImage,
  fileJson: faFileBracketsCurly,
  fileXml: faFileXml,
  flag: faFlag,
  floppyDisk: faFloppyDisk,
  folderOpen: faFolderOpen,
  gas: faFireFlameCurved,
  gasSolid: faFireFlameCurvedSolid,
  gauge: faGauge,
  gaugeHigh: faGaugeHigh,
  generator: faCircleBolt,
  globe: faGlobe,
  gridHorizontal: faGridHorizontal,
  gripDots: faGripDots,
  handshake: faHandshake,
  handWave: faHandWave,
  heat: faTemperatureSnow,
  home: faHouse,
  homeBlank: faHouseBlank,
  houseUser: faHouseChimneyUser,
  HTMLFile: faFileCode,
  image: faImagePolaroid,
  inbox: faInbox,
  info: faInfo,
  infoCircle: faCircleInfo,
  infoSolid: faCircleInfoSolid,
  infoSquare: faInfoSquareSolid,
  invoice: faFileInvoiceDollar,
  leaf: faLeaf,
  level: faWaterArrowUp,
  linkHorizontal: faLinkHorizontal,
  locationDot: faLocationDot,
  lock: faLock,
  login: faLockOpen,
  logout: faArrowRightFromBracket,
  map: faMap,
  mapLayers: faLayerGroup,
  mapLocationDot: faMapLocationDot,
  merge: faMerge,
  messageQuestionSolid: faMessageQuestion,
  meteo: faCloudSunRain,
  meter: faMeter,
  mobileButton: faMobileButton,
  move: faArrowsUpDownLeftRight,
  networkWired: faNetworkWired,
  newspaper: faNewspaper,
  notification: faBell,
  notificationTime: faGaugeSimpleMax,
  paperclip: faPaperclip,
  pause: faCirclePause,
  pdfDocument: faFilePdf,
  pellets: faTree,
  pieChart: faPieChart,
  pipeCircleCheck: faPipeCircleCheck,
  plus: faPlus,
  plusLarge: faPlusLarge,
  powerPointDocument: faFilePowerpoint,
  questionCircle: faQuestionCircle,
  rectangle: faRectangle,
  refresh: faArrowRotateRight,
  repeat: faArrowsRepeat,
  replace: faArrowsRetweet,
  report: faUserTag,
  reset: faArrowsRepeat,
  router: faRouter,
  scope: faLocationCrosshairs,
  scrubber: faScrubber,
  search: faSearch,
  settings: faGear,
  share: faShareNodes,
  shieldCheck: faShieldCheck,
  shieldSlash: faShieldSlash,
  signal: faSignal,
  signalBarSlash: faSignalBarsSlash,
  sortLines: faArrowDownWideShort,
  sparkles: faSparkles,
  spinner: faSpinnerThird,
  steam: faCloud,
  suitcase: faSuitcase,
  table: faTable,
  tableLayout: faTableLayout,
  temperature: faTemperatureThreeQuarters,
  textDocument: faFileLines,
  threeDotMenu: faEllipsisStrokeVertical,
  thumbsUp: faThumbsUp,
  thumbtack: faThumbtack,
  thumbtackSolid: faThumbtackSolid,
  timer: faTimer,
  toolbox: faToolbox,
  triangleExclamation: faTriangleExclamation,
  triangleExclamationSolid: faTriangleExclamationSolid,
  unlinkHorizontal: faLinkHorizontalSlash,
  upload: faUpload,
  user: faUser,
  userFile: faFileUser,
  userSettings: faUserGear,
  users: faUsers,
  waiting: faHourglassClock,
  water: faDroplet,
  wifi: faWifi,
  wordDocument: faFileWord,
  wrench: faWrench,
  xMark: faXmark,
  xmarkCircle: faXmarkCircle,
  xmarkCircleSolid: faCircleXmarkSolid,
  zipFile: faFileZip,
  zoomIn: faMagnifyingGlassPlus,
  zoomOut: faMagnifyingGlassMinus,
} as const;
